import type { InterventionTemplateJsonEditorWrapperProps } from "./intervention-template-json-editor.type";

import InterventionTemplateJsonEditor from "./intervention-template-json-editor.component";

const InterventionTemplateJsonEditorWrapper = ({
  template,
}: InterventionTemplateJsonEditorWrapperProps) => {
  if (!template) return null;

  return <InterventionTemplateJsonEditor template={template} />;
};

export default InterventionTemplateJsonEditorWrapper;
